import React from "react";

import Scroll from '../../Layout/SmoothScroll';
import { motion } from "framer-motion"
import { Link } from "react-router-dom";
import { useState } from "react";
const Front = () => {
  const textAnimate={
    offscreen:{x:100, opacity:0},
    onscreen:{x:0,
    opacity:1,
    transition: {type:"spring",
    bounce:0.25,
    duration:0.5}}
  }
  const [hoveredImage, setHoveredImage] = useState(0)
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.75 }}
    >
      <Scroll />
      <div className="magazine-wrap">
        <motion.div 
          className="left-unit"
          initial={{ translateX: "100%" }}
          animate={{ translateX: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* <img src={logo} className="App-logo" alt="logo" /> */}
          <motion.img 
          src={require("../../Images/magazine-07-Cover.jpg")} 
          className={"front-left-img list-img"} 
          alt="" 
          
          style={hoveredImage === 0 ? { opacity: 1 } : { opacity: 0 }}
          />
          <img style={hoveredImage === 1 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/1-MADE-OF-CROVIE.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 2 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/2-WHISKY-DISTILLERIES.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 3 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/3-A-WEEKEND-EXPLORING-THE-CAIRNGORMS.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 4 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/4-SPINNING-A-GOOD-YARN.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 5 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/5-SIGNS-OF-THE-TIMES.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 6 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/6-THE-WINTERING-GEESE-OF-ISLAY.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 7 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/7-WILD-KABN-KITCHEN.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 8 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/8-RECIPE-FROM-WILD-KABN-KITCHEN.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 9 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/9-RECIPE-FROM-WILD-KABN-KITCHEN.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 10 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/10-SCOTLAND-ONE-STEP-AT-A-TIME.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 11 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/11-FOLKLORE-MYTHS-LEGENDS.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 12 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/12-TRULY-SCOTTISH-SPORTING-TRADITIONS.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 13 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/13-PEOPLE-POWER.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 14 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/14-DISCOVERING-THE-NOOKS-CRANNIES-OF-PERTHSHIRE.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 15 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/15-MEET-THE-MAKAR-KATHLEEN-JAMIE.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 16 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/16-WHATS-ON-SCOTLAND.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 17 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/17-LIVING-IN-THE-PAST.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 18 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/18-A-HIDDEN-SCOTLAND-GUIDE.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 19 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/19-BARE-BONES-CHOCOLATE.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 20 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/20-RECIPE.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 21 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/21-THE-ART-OF-SELF-CATERING.jpg")} className={"front-left-img list-img"} alt="" />
          <img style={hoveredImage === 22 ? { opacity: 1 } : { opacity: 0 }} src={require("../../Images/22-YOUR-ESSENTIAL-GUIDE-TO-UP-HELLY-AA.jpg")} className={"front-left-img list-img"} alt="" />
        </motion.div>
        <motion.div
          initial={"offscreen"}
          whileInView={"onscreen"}
          viewport={{once:false, amount:0.5}}
          transition={{staggerChildren:0.25}}
          className="right-unit scroll-sec"
          >
            
              <div className="left-unit-mob">
                <img src={require("../../Images/magazine-07-Cover.jpg")} className={"front-left-img"} alt="" />
              </div>

            
              <motion.div
                onMouseEnter={() => setHoveredImage(1)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article1">
                  <h6>01 /</h6>
                  <h4>MADE OF CROVIE : Growing up on the edge of the ocean</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(2)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article2">
                  <h6>02 /</h6>
                  <h4>WHISKY DISTILLERIES : A roundup of some of Scotland's best whisky distillery experiences</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(3)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article3">
                  <h6>03 /</h6>
                  <h4>A WEEKEND EXPLORING THE CAIRNGORMS, a local's guide</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(4)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article4">
                  <h6>04 /</h6>
                  <h4>SPINNING A GOOD YARN : A tale of Scottish textiles from tartan to tweed</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(5)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article5">
                  <h6>05 /</h6>
                  <h4>SIGNS OF THE TIMES : Meet traditional signwriter Thomas Payne</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(6)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article6">
                  <h6>06 /</h6>
                  <h4>THE WINTERING GEESE OF ISLAY : The annual pilgrimage back to Scotland</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(7)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article7">
                  <h6>07 /</h6>
                  <h4>WILD KABN KITCHEN from the embers</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(8)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article8">
                  <h6>08 /</h6>
                  <h4>RECIPE FROM WILD KABN KITCHEN : Cast Iron Cullen Skink with Trout & Wild Herbs</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(9)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article9">
                  <h6>09 /</h6>
                  <h4>RECIPE FROM WILD KABN KITCHEN : Wild Venison Carpaccio on Sourdough</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(10)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article10">
                  <h6>10 /</h6>
                  <h4>SCOTLAND, ONE STEP AT A TIME : Long-distance walking in Scotland</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(11)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article11">
                  <h6>11 /</h6>
                  <h4>FOLKLORE, MYTHS & LEGENDS : The Fiddlers of Tomnahurich</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(12)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article12">
                  <h6>12 /</h6>
                  <h4>TRULY SCOTTISH SPORTING TRADITIONS</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(13)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article13">
                  <h6>13 /</h6>
                  <h4>PEOPLE POWER</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(14)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article14">
                  <h6>14 /</h6>
                  <h4>DISCOVERING THE NOOKS & CRANNIES OF PERTHSHIRE</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(15)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article15">
                  <h6>15 /</h6>
                  <h4>MEET THE MAKAR, KATHLEEN JAMIE : A conversation with Scotland's national poet</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(16)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article16">
                  <h6>16 /</h6>
                  <h4>WHAT'S ON SCOTLAND : Autumn - Winter</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(17)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article17">
                  <h6>17 /</h6>
                  <h4>LIVING IN THE PAST</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(18)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article18">
                  <h6>18 /</h6>
                  <h4>A HIDDEN SCOTLAND GUIDE : Experiencing Scottish traditions through local events</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(19)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article19">
                  <h6>19 /</h6>
                  <h4>BARE BONES CHOCOLATE, Cacao goodness</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(20)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article20">
                  <h6>20 /</h6>
                  <h4>RECIPE : Make your own Bare Bones hot chocolate</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(21)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article21">
                  <h6>21 /</h6>
                  <h4>THE ART OF SELF CATERING</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>

              <motion.div
                onMouseEnter={() => setHoveredImage(22)} onMouseLeave={() => setHoveredImage(0)}
                variants={textAnimate}
                className="article-list"
              >
                <Link to="/article22">
                  <h6>22 /</h6>
                  <h4>YOUR ESSENTIAL GUIDE TO UP HELLY AA</h4>
                  <h5>Ben Lerwill</h5>
                </Link>
              </motion.div>
              
            
          </motion.div>
      </div>
    </motion.div>
    
  );
}

export default Front;
